import { Component, OnInit } from '@angular/core';
import { CreditosService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';
@Component({
  selector: 'app-tarifas',
  templateUrl: './tarifas.component.html',
  styleUrls: ['./tarifas.component.css']
})
export class TarifasComponent implements OnInit {

  cols: any[];
  tarifas: any[];
  constructor(private creditosservice: CreditosService) { }

  ngOnInit(): void {
    swal2.showLoading();
    this.creditosservice.getRates().subscribe( resp => { this.tarifas = resp; console.log(this.tarifas) } );

this.cols = [
  
{ field: 'key', header: 'Key' },
{ field: 'description', header: 'Descripcion' },
{ field: 'value', header: 'Valor' },
{ field: 'herramientas', header: 'Herramientas' }
  
];
swal2.close();
  }

  borraTarifa( id: string ) {
    swal2.showLoading();
    swal2.fire({
    title: 'Desea Eliminar la tarifa',
    text: 'Seleccionada',
    icon: 'question',
    showConfirmButton: true,
    showCancelButton: true,
    allowOutsideClick: false
    }). then ( resp => {
    if ( resp.value) {
    
    this.creditosservice.borrarRate( id ).subscribe( () => {
    swal2.close();
    swal2.fire({
     title: 'La tarifa',
     text: 'fue eliminada con exito',
     icon: 'success',
     showConfirmButton: true,
     showCancelButton: false,
     allowOutsideClick: false
    }). then ( res => {
    
     if ( res.value ) {
       this.ngOnInit();
     }
    
    } );
    
    }, (err) => {
    swal2.close();
    console.log(err);
    console.clear();
    swal2.fire({
     title: 'Ocurrio un error',
     text: '',
     icon: 'error',
     showConfirmButton: true,
     showCancelButton: false,
     allowOutsideClick: false
    }). then ( res => {
     if ( res.value ) {
       this.ngOnInit();
     }
    } );
    } );
    
    }
    });
    
    }

}
